module.exports = __webpack_public_path__ + "static/media/Comp 1.a036e49e.gif";